module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-six-members/key-pasir-ris/key-1.svg?v=7db8f947";